import { useEffect } from 'react'
import { tickerSocket } from '@entities/market'
import { useAuthStore } from '@features/auth'
import { useTickerStore } from './tickerStore'
import { applyTickerPriceAdjustment } from './tickerPriceAdjustment'
import { useSymbolMapStore } from './symbolMapStore'

export const useTickerSocket = (connected: boolean, symbols: string[] = []) => {
  useEffect(() => {
    if (!connected) return

    tickerSocket.connect()

    const remove = tickerSocket.addListener((incoming) => {
      const adjusted = applyTickerPriceAdjustment(incoming, {
        brokerId: useAuthStore.getState().brokerId,
        symbolMap: useSymbolMapStore.getState().symbolMap,
      })
      useTickerStore.getState().mergeTickers(adjusted)
    })

    return () => {
      remove()
      tickerSocket.unsubscribe()
      tickerSocket.disconnect()
      useTickerStore.getState().reset()
    }
  }, [connected])

  useEffect(() => {
    if (!connected) return

    useTickerStore.getState().retainSymbols(symbols)

    if (symbols.length === 0) {
      tickerSocket.unsubscribe()
      return
    }

    tickerSocket.subscribe(symbols)
  }, [connected, symbols])
}
